import { ChangeEvent, memo } from 'react';
import { TertiaryGraySmall, TertiarySmall } from '../button/button';
import { SelectSmall } from '../forms/select';
import { Icons } from '../icons/icons';

type Props = {
  pageCount: number;
  pageIndex: number;
  canNextPage: boolean;
  nextPage: () => void;
  canPreviousPage: boolean;
  previousPage: () => void;
  gotoPage: (page: number) => void;
  pageSize: number;
  rowsLength: number;
  setPageSize: (size: number) => void;
};

export const Pagination = memo((props: Props): JSX.Element => {
  const mid = 3;
  const items = [];
  const btnLimit = 7;
  const itemsIndex = props.pageCount - 1;
  const from = props.pageIndex * props.pageSize + 1;
  const toItem = (props.pageIndex + 1) * props.pageSize;

  items.push(<TertiaryGraySmall key="prev" onClick={(): void => { props.previousPage(); }} disabled={!props.canPreviousPage}><Icons.LeftArrow /></TertiaryGraySmall>);

  for (let index = 0; index <= itemsIndex; index++) {
    let value: string | number | undefined = index + 1;

    if (index !== 0 && index !== itemsIndex && itemsIndex >= btnLimit) {
      if ((index === 1 && props.pageIndex > mid) || (itemsIndex - 1 === index && itemsIndex - props.pageIndex > mid)) {
        value = '...';
      } else if ((props.pageIndex <= mid && index > mid + 1) ||
        (props.pageIndex + mid >= itemsIndex && itemsIndex - mid - 1 > index) ||
        (itemsIndex - props.pageIndex > mid && props.pageIndex > mid && (props.pageIndex - index > 1 || props.pageIndex + 1 < index))) {
        value = undefined;
      }
    }

    if (index === props.pageIndex) {
      items.push(<TertiarySmall key={index} onClick={(): void => props.gotoPage(index)}>{index + 1}</TertiarySmall>);
    } else if (typeof value === 'number') {
      items.push(<TertiaryGraySmall key={index} onClick={(): void => props.gotoPage(index)}>{value}</TertiaryGraySmall>);
    } else if (typeof value === 'string') {
      items.push(<TertiaryGraySmall className="btn-dots" key={index} onClick={(): void => props.gotoPage(props.pageIndex)}>{value}</TertiaryGraySmall>);
    }
  }

  items.push(<TertiaryGraySmall key="next" onClick={(): void => { props.nextPage(); }} disabled={!props.canNextPage}><Icons.RightArrow /></TertiaryGraySmall>);

  return <div className="d-flex justify-content-between table-info">
    {props.rowsLength > 0 && <div className="table-page-info">
        {`Showing ${from} to ${(toItem > props.rowsLength ? props.rowsLength : toItem)} of ${props.rowsLength} entries`}
      </div>
    }
    {props.rowsLength > 10 && <div className='d-flex table-pagination'>{items}</div>}
    {props.rowsLength > 10 && <div className="d-flex table-select-container">
      Show
      <SelectSmall
        name="show"
        className="select-table-size"
        onChange={(event: ChangeEvent<HTMLSelectElement>): void => {
          props.setPageSize(parseInt(event.target.value, 10));
        }}
        options={[{ value: '10', label: '10' }, { value: '50', label: '50' }, { value: '100', label: '100' }]}
        />
      entries
    </div>
    }
  </div>;
});
